// 具体怎么做
import Vue from 'vue'
import VueRouter from 'vue-router'
//在router文件夹下面的index.js文件里面引入这三个页面组件
 import AboutMy from '../views/about'
 import ShouYe from '../views/index'
 import ProductS from '@/views/product'
 import NewS from "@/views/news";
 import ContactS from "@/views/contact";
 import NewsInfo from '@/views/newsinfo.vue'
 import ListDetails from "@/views/listdetails.vue";
 import searchResults from "@/views/search.vue";
//  import LayoutPage from "@/views/Layout";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'  // 将根路径重定向到目标页面
  },
  {
    path: '/index',
    name: 'ShouYe',
    component: ShouYe,
    // component: () => import('../views/index.vue'),
    meta: {
      title: '首页' // 网站名称
    }
  },
  {
    path: '/about',
    name: 'AboutMy',
    component: AboutMy,
    // component: () => import('../views/about.vue'),
    meta: {
      title: '关于我们' // 网站名称
    }
  },
  {
    path: '/product',
    name: 'ProductS',
    component: ProductS,
    // component: () => import('../views/product.vue'),
    meta: {
      title: '产品与服务' // 网站名称
    }
  },
  {
    path: '/news',
    name: 'NewS',
    component: NewS,
    // component: () => import('../views/news.vue'),
    meta: {
      title: '新闻中心' // 网站名称
    }
  },
  {
    path: '/newsinfo',
    name: 'NewsInfo',
    component: NewsInfo,
    // component: () => import('../views/newsinfo.vue'),
    meta: {
      title: '新闻详情' // 网站名称
    }
  },
  {
    path: '/newsinfo/:id',
    name: 'NewsInfo',
    component: NewsInfo,
    // component: () => import('../views/newsinfo.vue'),
    meta: {
      title: '新闻详情' // 网站名称
    }
  },
  {
    path: '/listdetails',
    name: 'ListDetails',
    component: ListDetails,
    // component: () => import('../views/newsinfo.vue'),
    meta: {
      title: '列表详情' // 网站名称
    }
  },
  {
    path: '/listdetails/:id',
    name: 'ListDetails',
    component: ListDetails,
    // component: () => import('../views/newsinfo.vue'),
    meta: {
      title: '列表详情' // 网站名称
    }
  },
  {
    path: '/search:query',
    name: 'searchResults',
    component: searchResults,
    // component: () => import('../views/newsinfo.vue'),
    meta: {
      title: '新闻列表' // 网站名称
    }
  },
  

  {
    path: '/contact',
    name: 'ContactS',
    component: ContactS,
    // component: () => import('../views/contact.vue'),
    meta: {
      title: '联系我们' // 网站名称
    }
  }
]


const router = new VueRouter({
  routes
})

export default router
